import { Dispatch, SetStateAction } from 'react';

import { ArrowDownTrayIcon, PaperAirplaneIcon } from '@heroicons/react/16/solid';

import { useTranslation } from 'react-i18next';

import Button from 'components/Button';

import Title from 'pages/FlightOffer/Title';
import AgreementCheckbox from 'pages/FlightOffer/AgreementCheckbox';

const FlightInformationSection = ({
  pdfUrl,
  hasAlreadyAgreed,
  isFlightInfoAgreed,
  setFlightInfoAgreed,
}: {
  pdfUrl: string;
  hasAlreadyAgreed: boolean;
  isFlightInfoAgreed: boolean;
  setFlightInfoAgreed: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col max-lg:gap-[16px]'>
      <div className='flex justify-between  max-lg:flex-col max-lg:items-center max-lg:gap-[16px]'>
        <Title text={t('flightOffer.flightInformation')} />
        <AgreementCheckbox
          label={t('flightOffer.agreeFlightInfo')}
          checked={isFlightInfoAgreed || hasAlreadyAgreed}
          onChange={setFlightInfoAgreed}
          disabled={hasAlreadyAgreed}
        />
      </div>
      <div className='px-[10px] py-[15px] rounded-[12px] shadow-[4px_4px_4px_4px_rgba(0,0,0,0.04)] flex justify-between'>
        <div className='flex items-center gap-[6px]'>
          <PaperAirplaneIcon className='size-8 max-lg:size-6 fill-primary max-sm:hidden' />
          <div className='font-[MuseoSansCyrl] text-primary text-[30px] max-lg:text-[20px]'>
            {t('flightOffer.offer')}
          </div>
        </div>
        <a href={pdfUrl} target='_blank' rel='noopener noreferrer' download>
          <Button className='w-[320px] flex gap-[8px] items-center justify-center max-lg:w-fit max-sm:hidden'>
            {t('flightOffer.download')}
            <ArrowDownTrayIcon className='size-4 fill-white' />
          </Button>
          <ArrowDownTrayIcon className='size-6 fill-primary sm:hidden' />
        </a>
      </div>
    </div>
  );
};

export default FlightInformationSection;
